import { motion } from 'framer-motion'
import EditIcon from '../../../../assets/svgs/EditIcon'
import PlusCircleIcon from '../../../../assets/svgs/PlusCircle'
import style from './MainProfile.module.css'

/* ---- School initials avatar with deterministic colour ---- */
const schoolColors = [
  '#1a237e', '#1565c0', '#2e7d32', '#4a148c',
  '#b71c1c', '#e65100', '#00695c', '#37474f',
]

const SchoolAvatar = ({ schoolName }) => {
  const initials = schoolName
    ? schoolName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join('')
    : '?'

  const colorIdx = (schoolName?.charCodeAt(0) || 0) % schoolColors.length
  const bg = schoolColors[colorIdx]

  return (
    <div
      className={style.cardImage}
      style={{
        background: bg,
        color: '#fff',
        fontSize: initials.length > 1 ? 14 : 20,
        fontWeight: 700,
        fontFamily: 'Poppins, sans-serif',
        letterSpacing: '0.5px',
      }}
    >
      {initials}
    </div>
  )
}

const fadeUp = {
  hidden: { opacity: 0, y: 14 },
  visible: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.38, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] },
  }),
}

const Education = ({ userProfile, toggleModal, owner, removeComponent, editMode }) => {
  if (!userProfile.education?.length) return null

  return (
    <div className={style.educationWrapper}>
      <div className={style.educationActions}>
        <p className={style.title}>Education</p>
        {owner && editMode && (
          <div
            className={style.plus}
            onClick={() => toggleModal('education', userProfile, 'create')}
            title="Add education"
          >
            <PlusCircleIcon color="white" />
          </div>
        )}
      </div>

      <motion.div
        className={style.cardsContainer}
        initial="hidden"
        animate="visible"
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      >
        {userProfile.education.map((item, index) => (
          <motion.div
            className={style.singleCard}
            key={index}
            variants={fadeUp}
            custom={index}
          >
            <SchoolAvatar schoolName={item.school_name} />

            <div className={style.cardInfo}>
              <p className={style.cardTitle}>{item.school_name}</p>
              {item.degree && (
                <p className={style.cardCompany}>
                  {item.degree}
                  {item.field_of_study ? ` · ${item.field_of_study}` : ''}
                </p>
              )}
              {(item.start_date || item.end_date) && (
                <p className={style.cardSubtext}>
                  {item.start_date}
                  {item.end_date ? ` — ${item.end_date}` : ''}
                </p>
              )}
            </div>

            {owner && editMode && (
              <div
                onClick={() => toggleModal('education', item)}
                className={style.edit}
                title="Edit"
              >
                <EditIcon />
              </div>
            )}
          </motion.div>
        ))}
      </motion.div>
    </div>
  )
}

export default Education
